export const REFRESH_USER_STATE_FROM_COOKIE_TRACKER_KEY =
  'refresh-user-state-from-cookie';

export const INITIALIZE_STORAGE_SYNC_TRACKER_KEY = 'initialize-storage-sync';

export const FETCH_PROJECT_SETTINGS_TRACKER_KEY = 'fetch-project-settings';

export const GENERATE_SESSION_KEYS_TRACKER_KEY = 'generate-session-keys';
